import type { TFilters } from '~/types/analytics-context'

import { DEFAULT_DAI_SINGLE_VALUE, DEFAULT_DATE_RANGE } from '~/const'
import { BUSINESS_REPORTS_FEATURE_PREFIX } from '~/const/analytics-context'

export const DEFAULT_KPI = 'installation_date'

export const DEFAULT_COUNTRY = 'US'

export const computeFilters = (
  filters: TFilters
): {
  key: string
  value: string[]
}[] => {
  return [
    { key: 'abtest_key', value: filters.abtestKey || [] },
    { key: 'app_key', value: filters.appKey || [] },
    { key: 'breakdown', value: filters.breakdown || [] },
    { key: 'country', value: filters.country || [] },
    { key: 'dai', value: filters.dai || DEFAULT_DAI_SINGLE_VALUE },
    { key: 'device_category', value: filters.deviceCategory || [] },
    { key: 'device_type', value: filters.deviceType || [] },
    { key: 'installation_app_version', value: filters.installationAppVersion || [] },
    { key: 'installation_country', value: filters.installationCountry || [DEFAULT_COUNTRY] },
    { key: 'kpi', value: filters.kpi || [DEFAULT_KPI] },
    { key: 'navigation_graph_id', value: filters.navigationGraphId || [] },
    { key: 'placement_key', value: filters.placementKey || [] },
    { key: 'ua_source', value: filters.uaSource || [] },
    { key: 'user_type', value: filters.userType || [] },
  ]
}

export const computeFiltersDate = (
  filters: TFilters
): {
  range: {
    end: string
    start: string
  }
} => {
  const { endDate, startDate } = filters
  const dateRange = {
    end: endDate ? endDate[0] : DEFAULT_DATE_RANGE.end,
    start: startDate ? startDate[0] : DEFAULT_DATE_RANGE.start,
  }

  return {
    range: dateRange,
  }
}

export const isBusinessReportsFeature = (featureName?: string): boolean =>
  !!featureName && featureName.includes(BUSINESS_REPORTS_FEATURE_PREFIX)
